import { render } from "./AnchorHome.vue?vue&type=template&id=0a072358&scoped=true"
import script from "./AnchorHome.vue?vue&type=script&lang=js"
export * from "./AnchorHome.vue?vue&type=script&lang=js"

import "./AnchorHome.vue?vue&type=style&index=0&id=0a072358&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a072358"]])

export default __exports__